import React from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';

import FormSubmitButton from '../FormSubmitButton';
import PasswordField from '../PasswordField';

import { formValidate } from '@eb/eds-utils';
import {
    newSignupValidate as validate,
    asyncValidateConfirmEmail as asyncValidate,
} from '../utils';

import { SET_PASSWORD_FORM } from '../../constants';

class ResetPasswordForm extends React.Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        buttonCTA: translationPropType,
        buttonStyle: PropTypes.string,
        /* Props Provided Via ReduxForm */
        submitFailed: PropTypes.bool,
        submitting: PropTypes.bool,
    };

    render() {
        const {
            handleSubmit,
            buttonCTA,
            submitting,
            submitFailed,
            buttonStyle,
        } = this.props;

        const submitDisabled = submitting;

        return (
            <form
                onSubmit={handleSubmit}
                noValidate="novalidate"
                className="eds-fx--fade-in eds-fx--delay-2 eds-l-pad-bot-5"
            >
                <PasswordField submitFailed={submitFailed} />
                <FormSubmitButton
                    submitDisabled={submitDisabled}
                    buttonClasses="eds-fx--fade-in-down eds-fx--delay-1 eds-l-mar-top-8"
                    buttonCTA={buttonCTA}
                    style={buttonStyle}
                />
            </form>
        );
    }
}

export default formValidate({
    validate,
    asyncValidate,
    form: SET_PASSWORD_FORM,
    touchOnChange: true,
    touchOnBlur: false,
})(ResetPasswordForm);
